import React, { useState } from 'react';
import {
  CalendarIconContainer,
  InputContainer,
  StyledMyAuditContainer,
  StyledTextLabel,
  InputContainerDatePiker,
} from './styled.myAuditAssign';
import DatePicker from 'react-datepicker';
import {
  castSelectedDateWithoutConversion,
  convertUTCDateDisplay,
} from '../../../../helpers/dates';
import { useLocation, useNavigate } from 'react-router-dom';
import { getItem, setItem } from '../../../../utils/localStorage';
import { showErrorMessage } from '../../../../helpers/showMessage';
import { ButtonLarge } from '../../../common/sharedComponents/buttons/ButtonLarge';
import { useTranslation } from 'react-i18next';
import { Calendar } from '../../../common/icons/Calendar';
import { CloseCircleDark } from '../../../common/icons/CloseCircleDark';
import { Headline2 } from '../../../common/typography';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { MyAuditSubTitle } from '../../../myAudit/components/MyAuditSubtitle';
import { TextArea } from './../../../common/sharedComponents/TextArea';
import { TextInput } from './../../../common/sharedComponents/TextInput';
import { Body5 } from './../../../common/typography';
import { SearchBox } from './../../../common/sharedComponents/SearchBox';
import { ISelectedOption } from '../../../@types/searchBox';
import { useSearchUser } from '../../../common/hooks/useSearchUser';
import {
  IMyAuditPayload,
  IMyAuditPayloadSection,
  IMyAuditPayloadSectionCreation,
  IMyAuditPreviewCard,
  IMyAuditSectionData,
} from './../../../@types/myAudit';
import {
  filterOptions,
  handleOptionClickUtil,
} from './../../../common/sharedComponents/SearchBox/utils';
import { ErrorValidation } from '../../../../app/common/sharedComponents/ErrorValidation';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';
import {
  ButtonContainer,
  HeaderContainer,
} from '../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { DatePickerWrapper } from '../../../common/sharedStyledComponents/Datepicker.styled';
import UnsavedFormDataModal from '../../../../components/commons/UnsavedFormDataModal';

type MyAuditAssignFields = 'Assignee' | 'Due Date' | 'Subject' | 'Notes';

export function MyAuditAssign () {
  const navigate = useNavigate();
  const location: any = useLocation();
  const {
    templateName,
    myAuditPreview,
    sectionsData,
    isAllSectionsSelected,
    filteredSection,
    currentAuditorIndex,
  } = location.state;
  const { t } = useTranslation();
  const myAudit: IMyAuditPayload = getItem('myAudit');
  const alreadyAssignedUser = myAudit.sections.map(
    (section) => section.auditorId
  );
  const myAuditPreviewCards: IMyAuditPreviewCard[] = myAuditPreview;
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchUser([], alreadyAssignedUser);
  let auditorIndex = currentAuditorIndex || 0;
  const myAuditDueDate = myAudit.sections.map((section) => section.dueDate)[0];
  const myAuditSubject = myAudit.subject;
  const myAuditNotes =
    filteredSection &&
    filteredSection.map((section: IMyAuditPayloadSection) => section.notes)[0];
  const [dueDate, setDueDate] = useState<string>(myAuditDueDate);
  const [subject, setSubject] = useState<string>(myAuditSubject);
  const [notes, setNotes] = useState<string>('');
  const [missingFields, setMissingFields] = useState<MyAuditAssignFields[]>([]);
  const [auditor, setAuditor] = useState<ISelectedOption>();
  const [isUnsavedDataModal, setShowUnsavedDataModal] =
    useState<boolean>(false);
  const [subjectError, setSubjectError] = useState(false);
  const [notesError, setNotesError] = useState(false);

  const validateAssignMyAudit = () => {
    const missingFieldsArray: MyAuditAssignFields[] = [];
    const hasAuditorId = sectionsData.some(
      (section: IMyAuditPayloadSectionCreation) => section.auditorId
    );
    if (!subject) {
      missingFieldsArray.push('Subject');
    }
    if (!dueDate) {
      missingFieldsArray.push('Due Date');
    }
    if (!hasAuditorId) {
      missingFieldsArray.push('Assignee');
    }
    if (!notes) {
      missingFieldsArray.push('Notes');
    }
    setMissingFields(missingFieldsArray);
    return missingFieldsArray.length > 0;
  };

  const validateHasAuditor = () => {
    return sectionsData.find((section) => section.auditorId);
  };

  const updateMyAuditSections = () => {
    const convertedSectionData = sectionsData.map(
      (section: IMyAuditSectionData) => {
        return {
          templateSectionId: section.templateSectionId,
          auditorId: section.auditorId,
          dueDate: section.dueDate,
          notes,
        };
      }
    );
    myAudit.sections = [...myAudit.sections, ...convertedSectionData];
    myAudit.subject = subject;
  };

  const finaliseHandler = () => {
    const notHaveAuditorId = !validateHasAuditor();
    const isAuditMissingFields = validateAssignMyAudit();

    if (isAuditMissingFields || notHaveAuditorId) {
      showErrorMessage(t('COMMON.MY_AUDIT.ASSIGN_FORM.ERROR_MESSAGE'));
      return;
    }

    myAuditPreviewCards[auditorIndex].auditor = auditor;
    myAuditPreviewCards[auditorIndex].sectionsCard!.dueDate = dueDate;
    updateMyAuditSections();

    setItem('myAudit', myAudit);
    navigate('/myaudit/preview', {
      state: {
        templateName,
        myAuditPreview: myAuditPreviewCards,
      },
    });
  };

  const handleSaveAndAssignMore = () => {
    const notHaveAuditorId = !validateHasAuditor();
    const isAuditMissingFields = validateAssignMyAudit();
    if (isAuditMissingFields || notHaveAuditorId) {
      showErrorMessage(t('COMMON.MY_AUDIT.ASSIGN_FORM.ERROR_MESSAGE'));
      return;
    }
    myAuditPreviewCards[auditorIndex].auditor = auditor;
    myAuditPreviewCards[auditorIndex].sectionsCard!.dueDate = dueDate;
    auditorIndex++;
    updateMyAuditSections();
    setItem('myAudit', myAudit);
    navigate(`/myaudit/sections`, {
      state: {
        templateName,
        myAuditPreview: myAuditPreviewCards,
        currentAuditorIndex: auditorIndex,
      },
    });
  };

  const handleBack = () => {
    navigate(`/myaudit/sections`, {
      state: {
        templateName,
        myAuditPreview: myAuditPreviewCards,
        currentAuditorIndex: auditorIndex,
      },
    });
  };

  function handleInputChange (value: string) {
    setSearchText(value);
    setSearchBoxOptions(filterOptions(value, searchBoxOptions));
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    sectionsData.forEach((section) => {
      section.auditor = selected;
      section.auditorId = selected.id;
      setAuditor(selected);
    });
    if (missingFields.length > 0 && selected) {
      const filteredMissingFields = missingFields.filter(
        (field) => field !== 'Assignee'
      );
      setMissingFields(filteredMissingFields);
    }
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
    setSearchText(selected.text);
  }

  function clearSearch () {
    setSearchText('');
    setSelectedOptions([]);
    removeAssignee();
  }

  function removeAssignee () {
    sectionsData.map((section) => {
      section.auditorId = null;
    });
  }

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.MY_AUDIT.TITLE')}
          onClick={() => setShowUnsavedDataModal(true)}
        />
      </HeaderContainer>
      <StyledMyAuditContainer>
        <Headline2>{t('COMMON.MY_AUDIT.TITLES.ASSIGN_MY_AUDIT')}</Headline2>
        <MyAuditSubTitle
          department={templateName}
          sections={sectionsData.map((section) => section.sectionName)}
        />
        <InputContainer>
          <SearchBox
            handleInputChange={handleInputChange}
            searchBoxOptions={searchBoxOptions}
            handleOptionClick={handleOptionClick}
            selectedOptions={selectedOptions}
            searchTextName={searchText}
            clearSearch={clearSearch}
            placeholderText={t('COMMON.MY_AUDIT.ASSIGN_FORM.PlACE_HOLDER')}
            label={t('COMMON.MY_AUDIT.PAGES.ASSIGN.ASSIGN_TO')}
            isError={
              missingFields.length > 0 && missingFields.includes('Assignee')
            }
          />
          <DatePickerWrapper>
            <StyledTextLabel>
              <Body5 color="eerieBlack">
                {t('COMMON.MY_AUDIT.SUMMARY_CARD.DUE_DATE')}
              </Body5>
            </StyledTextLabel>
            <InputContainerDatePiker>
              <DatePicker
                className={`${
                  missingFields.length > 0 && missingFields.includes('Due Date')
                    ? 'myaudit-date-picker-validate-form'
                    : 'myaudit-date-picker-form'
                }`}
                popperClassName="date-picker-popper"
                dateFormat="dd-MM-yyyy"
                minDate={new Date()}
                onFocus={(event: React.ChangeEvent<HTMLInputElement>) =>
                  event.target.blur()
                }
                disabled={myAudit.sections.length > 0}
                selected={dueDate ? convertUTCDateDisplay(dueDate) : null}
                onChange={(selectedDate) => {
                  if (missingFields.length > 0 && selectedDate) {
                    const filteredMissingFields = missingFields.filter(
                      (field) => field !== 'Due Date'
                    );
                    setMissingFields(filteredMissingFields);
                  }
                  if (selectedDate) {
                    const date = castSelectedDateWithoutConversion(
                      selectedDate,
                      'YYYY-MM-DD'
                    );
                    setDueDate(date);
                    sectionsData.map((section) => {
                      section.dueDate = date;
                    });
                  }
                }}
              />
              {!myAuditDueDate && (
                <CalendarIconContainer>
                  {dueDate ? (
                    <CloseCircleDark
                      onClick={() => {
                        setDueDate('');
                        sectionsData.map((section) => {
                          section.dueDate = '';
                        });
                      }}
                    />
                  ) : (
                    <Calendar />
                  )}
                </CalendarIconContainer>
              )}
            </InputContainerDatePiker>
            {missingFields.length > 0 && missingFields.includes('Due Date') && (
              <ErrorValidation
                message={t(
                  'COMMON.MY_AUDIT.ASSIGN_FORM.PLEASE_SELECT_VALID_DUE_DATE'
                )}
              />
            )}
          </DatePickerWrapper>
          <TextInput
            title={t('COMMON.MY_AUDIT.SUMMARY_CARD.SUBJECT')}
            textValue={subject}
            placeholder={t('COMMON.MY_AUDIT.SUMMARY_CARD.SUBJECT_NAME')}
            maxLength={250}
            isError={missingFields.length > 0 && missingFields.includes('Subject') || subjectError}
            onValueChange={(textValue) => {
              if (textValue.length > 250) {
                setSubjectError(true);
                showErrorMessage(t('COMMON.MY_AUDIT.SUMMARY_CARD.SUBJECT_MAX_LENGTH_ERROR') || 'Max 250 characters allowed');
                return;
              }
              
              setSubjectError(false);
              if (missingFields.length > 0 && textValue) {
                const filteredMissingFields = missingFields.filter(
                  (field) => field !== 'Subject'
                );
                setMissingFields(filteredMissingFields);
              }
              setSubject(textValue);
            }}
            disabled={myAudit.sections.length > 0}
          />
          <TextArea
            title={t('COMMON.MY_AUDIT.SUMMARY_CARD.NOTES')}
            textValue={myAuditNotes || notes}
            placeholder={t('COMMON.MY_AUDIT.SUMMARY_CARD.TYPE_YOUR_NOTES_HERE')}
            maxLength={500}
            isError={missingFields.length > 0 && missingFields.includes('Notes') || notesError}
            onValueChange={(textValue) => {
              if (textValue.length > 500) {
                setNotesError(true);
                showErrorMessage(t('COMMON.MY_AUDIT.SUMMARY_CARD.NOTES_MAX_LENGTH_ERROR') || 'Max 500 characters allowed');
                return;
              }

              setNotesError(false);
              if (missingFields.length > 0 && textValue) {
                const filteredMissingFields = missingFields.filter(
                  (field) => field !== 'Notes'
                );
                setMissingFields(filteredMissingFields);
              }
              setNotes(textValue);
            }}
          />
        </InputContainer>
        <ButtonContainer>
          <ButtonBlockColumn>
            <ButtonLarge
              title={t('COMMON.MY_AUDIT.BUTTON.SAVE_AND_ASSIGN')}
              backgroundColor="oxfordBlue"
              onClick={handleSaveAndAssignMore}
              disabled={isAllSectionsSelected}
            />
            <ButtonLarge
              title={t('COMMON.MY_AUDIT.BUTTON.FINALISE')}
              backgroundColor="verdigris"
              textColor="oxfordBlue"
              onClick={finaliseHandler}
            />
            <ButtonLarge
              outlined={true}
              inverted={true}
              title={t('COMMON.MY_AUDIT.BUTTON.BACK')}
              backgroundColor="eerieBlack"
              onClick={() => setShowUnsavedDataModal(true)}
            />
          </ButtonBlockColumn>
        </ButtonContainer>
      </StyledMyAuditContainer>
      {isUnsavedDataModal && (
        <UnsavedFormDataModal
          showUnsavedDataModal={isUnsavedDataModal}
          setShowUnsavedDataModal={setShowUnsavedDataModal}
          onContinue={handleBack}
        />
      )}
    </>
  );
}
